import { useState } from "react";
// import useForm from '../../../../hooks/useForm';
import { Modal, Button } from '@prosolve/common-components-ui'
import FileUpload from '../../../sharedComponents/FileUpload';
import useDataBackgroundImage from '../../../dataHooks/useDataBackgroundImage';
// import useDataAttendees from "../../../../dataHooks/useDataAttendees";

const ExistingConfirmationModal = ({
  onClose,
  onUseExisting,
  onReplace
}) => {
  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onReplace} style={{ background: '#fa8900', color: '#ffffff' }}>
        {'Replace'}
      </Button>
      <Button onClick={onUseExisting} $colored={true}>
        {'Use Existing'}
      </Button>
    </div>
  )
  return (
    <Modal title='Replace or Use Existing?' isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div>{'The file you are attempting to upload already exists.'}</div>
        <div>{'Do you want to use the file that already exists or do you wish to replace this file with the uploaded file?'}</div>
        <div><span style={{ fontWeight: 'bold' }}>{'WARNING'}</span>{': If you replace this file, other assessments that use this image will also be effected and replaced with the uploaded file.'}</div>
      </div>
    </Modal>
  )
}

export default ({
  onClose,
  onSuccess,
}) => {

  const {
    fetchBackgroundImage,
    uploadBackgroundImage
  } = useDataBackgroundImage();

  const [files, setFiles] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const [existingConfirmationModalOpen, setExistingConfirmationModalOpen] = useState(false)

  const imageExistsCheck = async () => {
    if (files && files.length > 0) {
      const fileName = files[0].name

      let existingImageData
      try {
        existingImageData = await fetchBackgroundImage(fileName)
      } catch (e) {
        console.log(e)
      }

      if (existingImageData && existingImageData.success && existingImageData.fileUrl) {
        return existingImageData.fileUrl
      }
    }
  }

  const uploadImage = async () => {
    if (files && files.length > 0) {
      let uploadedImageData
      try {
        uploadedImageData = await uploadBackgroundImage(files)
      } catch (e) {
        console.log(e)
      }
      if (uploadedImageData && uploadedImageData.success && uploadedImageData.fileUrls 
        && uploadedImageData.fileUrls[0] && uploadedImageData.fileUrls[0].fileUrl) {
        onSuccess(uploadedImageData.fileUrls[0].fileUrl)
      }
    }
  }

  const onUseExisting = () => {
    onSuccess(existingConfirmationModalOpen)
    setExistingConfirmationModalOpen(undefined)
  }

  const onClickSubmit = async (e, skipExistingCheck) => {
    if (files && files.length > 0) {
      setIsBusy(true)
      
      let existingImage
      if (!skipExistingCheck) {
        existingImage = await imageExistsCheck()
      }

      // TODO: Allow for option to use already existing, or replace with new image
      if (existingImage) {
        setExistingConfirmationModalOpen(existingImage)
      } else {
        await uploadImage()
      }

      setIsBusy(false)
    }
  }

  const onFilesChanged = (filesUpdated = []) => {
    setFiles(filesUpdated)
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy || files.length < 1}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title='Upload Images' isAutoHeight={true} onClose={onClose} footer={footer}>
      {
        existingConfirmationModalOpen &&
        <ExistingConfirmationModal
          onClose={() => setExistingConfirmationModalOpen(undefined)}
          onUseExisting={onUseExisting}
          onReplace={(e) => onClickSubmit(e, true)}
        />
      }
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <FileUpload
          onFilesChanged={onFilesChanged}
          isSingleFile={true}
        />
      </div>
    </Modal>
  )
}